'use client';

import type { ResizeDirection } from '@/shared/lib/hooks/useResizeHandles';

interface ResizeHandlesProps {
  onMouseDown: (e: React.MouseEvent, direction: ResizeDirection) => void;
  onTouchStart: (e: React.TouchEvent, direction: ResizeDirection) => void;
}

const HANDLE_POSITIONS: Array<{
  direction: ResizeDirection;
  position: string;
  cursor: string;
}> = [
  // Corners
  {
    direction: 'nw',
    position: '-top-2 -left-2 md:-top-1 md:-left-1',
    cursor: 'cursor-nw-resize',
  },
  {
    direction: 'ne',
    position: '-top-2 -right-2 md:-top-1 md:-right-1',
    cursor: 'cursor-ne-resize',
  },
  {
    direction: 'sw',
    position: '-bottom-2 -left-2 md:-bottom-1 md:-left-1',
    cursor: 'cursor-sw-resize',
  },
  {
    direction: 'se',
    position: '-bottom-2 -right-2 md:-bottom-1 md:-right-1',
    cursor: 'cursor-se-resize',
  },
  // Edges
  {
    direction: 'n',
    position: '-top-2 left-1/2 -translate-x-1/2 md:-top-1',
    cursor: 'cursor-n-resize',
  },
  {
    direction: 's',
    position: '-bottom-2 left-1/2 -translate-x-1/2 md:-bottom-1',
    cursor: 'cursor-s-resize',
  },
  {
    direction: 'w',
    position: 'top-1/2 -left-2 -translate-y-1/2 md:-left-1',
    cursor: 'cursor-w-resize',
  },
  {
    direction: 'e',
    position: 'top-1/2 -right-2 -translate-y-1/2 md:-right-1',
    cursor: 'cursor-e-resize',
  },
];

export function ResizeHandles({
  onMouseDown,
  onTouchStart,
}: ResizeHandlesProps) {
  return (
    <>
      {HANDLE_POSITIONS.map(({ direction, position, cursor }) => (
        <div
          key={direction}
          className={`absolute w-5 h-5 md:w-3 md:h-3 bg-background border border-border ${cursor} touch-none ${position}`}
          onMouseDown={(e) => onMouseDown(e, direction)}
          onTouchStart={(e) => onTouchStart(e, direction)}
        />
      ))}
    </>
  );
}
